export const DEFAULT_DAILY_STEP_GOAL = 5000;
export const DEFAULT_MIN_STEP_INTERVAL_MS = 650;
export const DEFAULT_MOTION_THRESHOLD = 1.15;

export function localDayKey(value = Date.now()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function normalizeDailyStepGoal(value, fallback = DEFAULT_DAILY_STEP_GOAL) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.round(parsed) : fallback;
}

export function calculateStepProgress(steps, goal) {
  const safeSteps = Math.max(0, Math.round(Number(steps) || 0));
  const safeGoal = normalizeDailyStepGoal(goal);
  const percent = safeGoal > 0 ? Math.round((safeSteps / safeGoal) * 100) : 0;
  return { steps: safeSteps, goal: safeGoal, percent, visualPercent: Math.min(100, percent) };
}

export function motionIntensity(event) {
  const acceleration = event?.acceleration;
  if ([acceleration?.x, acceleration?.y, acceleration?.z].every(Number.isFinite)) {
    return Math.hypot(acceleration.x, acceleration.y, acceleration.z);
  }

  const gravity = event?.accelerationIncludingGravity;
  if ([gravity?.x, gravity?.y, gravity?.z].every(Number.isFinite)) {
    return Math.abs(Math.hypot(gravity.x, gravity.y, gravity.z) - 9.80665);
  }

  return 0;
}

export function isAcceptedStepSource(source) {
  return source === 'devicemotion';
}

export function shouldCountMotionSample({
  event,
  timestamp = Date.now(),
  lastStepAt = 0,
  threshold = DEFAULT_MOTION_THRESHOLD,
  minIntervalMs = DEFAULT_MIN_STEP_INTERVAL_MS,
  source = 'devicemotion',
} = {}) {
  if (!isAcceptedStepSource(source)) return false;
  if (!Number.isFinite(timestamp) || timestamp - Number(lastStepAt || 0) < minIntervalMs) return false;
  return motionIntensity(event) >= threshold;
}

export function stepStorageKey(userId, dayKey) {
  return `pfandpirat_step_counter_${String(userId || 'guest')}_${dayKey}`;
}
